<template>
  <div class="pages">
    <headers />
    <div class="main">
      <div class="title">{{dataObject.name}}</div>
      <div class="crumbsNav">
        <div class="crumbs">
          <span @click="returnPage">首页</span>
          <span @click="proInfo">
            <span class="style1">></span>
            {{dataObject.name}}
          </span>
          <span v-for="(item,index) in navList" :key="index" @click="nextLevelNav(index)">
            <span v-if="item != ''" class="navList">></span>
            {{item}}
          </span>
        </div>
        <div class="details">
          <p>
            <span>{{dataObject.file_total_num}}张</span>
            <span v-if="dataObject.file_total_size  < 1024 ">{{dataObject.file_total_size}}B</span>
            <span
              v-else-if="1024 <= dataObject.file_total_size &&dataObject.file_total_size < 1048576 "
            >{{(dataObject.file_total_size / 1024).toFixed(1)}}KB</span>
            <span
              v-else-if="1048576 <= dataObject.file_total_size && dataObject.file_total_size < 1073741824 "
            >{{(dataObject.file_total_size/1048576).toFixed(1)}}MB</span>
            <span
              v-else-if="1073741824 <= dataObject.file_total_size && dataObject.file_total_size < 1099511627776 "
            >{{(dataObject.file_total_size/1073741824).toFixed(1)}}GB</span>
            <span>{{dataObject.download_num}}次下载</span>
          </p>

          <div class="operation" @click="deletePro(dataObject.id)">删除项目</div>
          <div class="operation" :data-clipboard-text="url" id="share" @click="sharePro()">分享项目</div>
        </div>
      </div>
      <div class="imglist">
        <div class="imgItem" v-for="(item,index) in dataObject.file_list" :key="index">
          <div class="coverImg" @click="nextLevel(item.dir,item.name)">
            <img
              src="../../assets/img/wenjianjia.png"
              alt
              class="wenjianjia"
              v-if="item.is_dir == 1"
            />
            <img
              :src="'https://file.zuopin.cloud/' + item.object_key + '?imageMogr2/thumbnail/300x300'"
              alt
              class="dirImg"
              v-else
            />
          </div>
          <p>{{item.name}}</p>
        </div>
      </div>
    </div>

    <!-- 分享项目的弹窗 -->
    <!-- <div class="mask"> 
        <div class="conter">

        </div>
    </div>-->
  </div>
</template>

<script>
import headers from "../../components/header";
import Clipboard from "clipboard";

import {
  getDetails,
  deleteDetails,
  filelist
} from "@/request/api";

export default {
  components: { headers },
  name: "projectDetails",
  data() {
    return {
      dataObject: {},
      workId: 0,
      navList: [],
      url:'https://zuopin.cloud/home/index.html#/customerLogin'
    };
  },
  mounted() {
    this.proInfo();
  },
  methods: {
    // 获取项目信息
    proInfo() {
      var that = this;
      this.workId = this.$route.query.id;
      getDetails(this.workId).then(res => {
        console.log(res, "res");
        that.dataObject = res.data.data;
        that.navList = [];
      });
    },

    // 删除项目
    deletePro(id) {
      var that = this;
      deleteDetails(id).then(res => {
        console.log(res, "删除项目");
        that.returnPage();
      });
    },

    // 分享
    sharePro() {
      let clipboard = new Clipboard("#share");
      clipboard.on("success", e => {
         this.$message({
          message: '连接复制成功',
          type: 'success',
          offset:300
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", e => {
         this.$message({
          message: '连接复制成功,请重新复制',
          type: 'error',
          offset:300
        });
        // 释放内存
        clipboard.destroy();
      });

    },

    // 返回上一页
    returnPage() {
      this.$router.push({
        path: "/userHome"
      });
    },

    // 进入下级目录
    nextLevel(dir, name) {
      var that = this;
      var dirList = "";
      if (dir == "/") {
        dirList = dir + name;
      } else {
        dirList = dir + "/" + name;
      }
      var params = {
        work_id: this.workId,
        dir: dirList
      };

      filelist(params).then(res => {
        if (res.data.data.file_list.length != 0) {
          that.dataObject.file_list = res.data.data.file_list;
        }
        this.navList = res.data.data.file_list[0].dir.split("/");
        this.navList.shift();
      });
    },

    //点击导航返回目录
    nextLevelNav(index) {
      var that = this;
      var dir = "";
      var allDirNav = that.navList;
      console.log(allDirNav, index);
      for (let i = 0; i < allDirNav.length; i++) {
        dir = dir + "/" + allDirNav[i];
        if (i == index) {
          break;
        }
      }

      var params = {
        work_id: this.workId,
        dir: dir
      };

      filelist(params).then(res => {
        if (res.data.data.file_list.length != 0) {
          that.dataObject.file_list = res.data.data.file_list;
        }
        this.navList = res.data.data.file_list[0].dir.split("/");
        this.navList.shift();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  width: 83%;
  min-width: 1000px;
  margin: auto;
  .title {
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    margin-top: 30px;
    margin-bottom:20px;
  }
  .crumbsNav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .crumbs {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    .navList {
      margin-left: 10px;
    }
    .style1 {
      margin-left: 10px;
    }
    .details {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      p {
        display: inline-block;
      }
      span {
        margin-right: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .operation {
        display: inline-block;
        width: 102px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        background: #000;
        border-radius: 10px;
        color: #ffffff;
        margin-left: 10px;
        font-size: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
      }
    }
  }
  .imglist {
    margin-top: 37px;
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    float: left;
    .imgItem {
      width: 119px;
      text-align: center;
      margin-bottom: 10px;
      margin-right: 10px;
      .coverImg {
        width: 119px;
        height: 119px;
        border-radius: 6px;
        background: #e5e5e5;
        display: flex;
        justify-content: center;
        align-items: center;
        .wenjianjia {
          width: 40px;
          height: 36px;
        }
        .dirImg {
          width: 119px;
          height: 119px;
          object-fit: cover;
          border-radius: 6px;
        }
      }
      p {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-top: 8px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  .conter {
    width: 400px;
    height: 200px;
    background: #ffffff;
    border-radius: 20px;
  }
}
</style>